import qs from 'query-string';
import { get, post } from './baseApi';

export const TagApi = {
    fetch: (query, options) => get(`/tags?${qs.stringify(query)}`, options),
    create: (data, options) => post('/tags', data, options),
};
